import { Box, Grid, Typography, styled } from "@mui/material";

import { Link, useNavigate } from "react-router-dom";
import { PRODUCTS } from "pages/Products/constants";
import Objects from "./components/Objects";
import dafiLogo from "assets/logo/logo-w.png";
import productsOverviewBackground from "assets/products/product_overview_image.svg";

const ProductImageWrapper = ({ product, titleIsOnTop, index }) => {
  const navigate = useNavigate()
  return (
    <ProductImage
      onClick={() => navigate(`/lipbalm/show-case?product=${index}`)}
    >
      <ProductImageBox mainImage={product?.main_image} name={product.texts.englishName} titleIsOnTop={titleIsOnTop}>

        <img src={product.main_image} alt="" />
      </ProductImageBox>

      {/* {!titleIsOnTop && (
        <ProductTitle variant="h6">{product.texts.title}</ProductTitle>
      )} */}
    </ProductImage>
  );
};

function ProductOverview() {
  return (
    <ProductOverviewWrapper>
      <Grid
        sx={{ height: "var(--app-height)", pt: 3, pb: 10 }}
        container
      >
        <Grid item xs={12} sx={{ zIndex: 2 }}>
          <Box textAlign={"center"}>
            <img src={dafiLogo} alt="" width={120} />
            <Typography variant="h5" color="white" sx={{ pt: 2 }}>
              Fruity Lipbalm
            </Typography>
            <Typography variant="subtitle1" fontWeight={400} sx={{ pt: 1 }} lineHeight={1.3} color="white">
              بالم لب‌های دافی
              با ۴ رایحه متفاوت
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sx={{ zIndex: 2 }}>
          <Products display={"flex"} width={"100%"}>
            <ProductImageWrapper product={PRODUCTS[3]} index={3} titleIsOnTop/>
            <ProductImageWrapper product={PRODUCTS[0]} index={0}  />
            <ProductImageWrapper product={PRODUCTS[1]} index={1} titleIsOnTop />
            <ProductImageWrapper product={PRODUCTS[2]} index={2} />
          </Products>
        </Grid>
      </Grid>

      <Objects />
    </ProductOverviewWrapper>
  );
}

const ProductOverviewWrapper = styled(Box)(() => ({
  height: "var(--app-height)",
  width: "100%",
  position: "relative",
  overflow: "hidden",
  backgroundImage: `url(${productsOverviewBackground})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",

  // "&:before": {
  //   content: '""',
  //   position: "absolute",
  //   left: "0",
  //   top: "50%",
  //   width: "200%",
  //   background: `linear-gradient(45deg, ${PRODUCTS[0].colors.secondary} 0%, ${PRODUCTS[1].colors.secondary} 13%, ${PRODUCTS[2].colors.secondary} 25%, ${PRODUCTS[3].colors.secondary} 37%, ${PRODUCTS[0].colors.secondary} 50%, ${PRODUCTS[1].colors.secondary} 63%, ${PRODUCTS[2].colors.secondary} 75%, ${PRODUCTS[3].colors.secondary} 87%, ${PRODUCTS[0].colors.secondary} 100%)`,
  //   height: "80px",
  //   transform: "translateY(-50%)",
  //   zIndex: 1,
  //   animation: "movement-left 5s alternate infinite linear",
  //   border: "3px solid #ffffff",
  //   boxShadow: "0px 0px 33px 0px rgba(0,0,0,0.4) inset",
  // },

  // "&:after": {
  //   content: '""',
  //   position: "absolute",
  //   left: "50%",
  //   top: "50%",
  //   width: "3px",
  //   height: "100%",
  //   transform: "translate(-50%, -50%)",
  //   zIndex: 0,
  //   background: "#ffffff",
  // },

  "@keyframes movement-left": {
    "0%": {
      left: "-10px",
    },
    "100%": {
      left: "-100%",
    },
  },

  "@keyframes image-zooming-overview": {
    "0%": {
      transform: "scale(1) rotate(0)",
      filter: "drop-shadow(0 0 0 0px rgba(0, 0, 0, 0.2))",
    },

    "100%": {
      transform: "scale(1.05) rotate(4deg)",
      filter: "drop-shadow(0 0 0 20px rgba(0, 0, 0, 0))",
    },
  },

  // "@keyframes pulse": {
  //   "0%": {
  //   },

  //   "100%": {
  //   },
  // },
}));

const ProductImage = styled(Box)(() => ({
  display: "flex",
  width: "100%",
  flexDirection: "column",
  position: "relative",
  cursor: "pointer",

  "&:after": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },

  
}));

const ProductImageBox = styled(Box)(({ theme, name, titleIsOnTop, mainImage }) => ({

  "&:before": {
    content: `'${name}'`,
    position: "absolute",
    color: "white",
    fontSize: "20px",
    whiteSpace: "nowrap",
    top: "105%",
    left: "50%",
    transform: "translate(-50%, -50%)",

    [theme.breakpoints.down('md')]: {
      top: "95%",
      fontSize: "14px",
      maxHeight: "190px",
    },

    [theme.breakpoints.down('sm')]: {
      top: "95%",
      fontSize: "12px",
      maxHeight: "190px",
    },

    
    
  },

  '&:after' : {
    content: '""',
    position: 'absolute',
    backgroundImage: `url(${mainImage})`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    width: "100%",
    height: "100%",
    maxHeight: "290px",
    left: '50%',
    top: '50%',
    animation: `pulse 2s infinite`,
    zIndex: '-1',
    filter: 'blur(2px) sepia(1) opacity(0.3)',
    transform: "translate(-50%, -50%)",
    opacity: 0,

    [theme.breakpoints.down('md')]: {
      animation: `pulse-laptop 2s infinite`,
      maxHeight: "190px",
    },
    
    [theme.breakpoints.down('sm')]: {
      maxHeight: "170px",
      animation: `pulse-mobile 2s infinite`,
    },

    "@keyframes pulse": {
      "0%": {
        width: "100%",
        maxHeight: "290px",
        opacity: '1'
      },

      "50%": {
        width: "170%",
        maxHeight: "420px",
        opacity: 0
      },
      
      "100%": {
        width: "100%",
        maxHeight: "290px",
        opacity: '0'
      },
    },

    "@keyframes pulse-laptop": {
      "0%": {
        width: "100%",
        maxHeight: "190px",
        opacity: '1'
      },
      
      "50%": {
        width: "150%",
        maxHeight: "320px",
        opacity: 0,
      },
      "100%": {
        width: "100%",
        maxHeight: "190px",
        opacity: '0'
      },
    },

    "@keyframes pulse-mobile": {
      "0%": {
        width: "100%",
        maxHeight: "170px",
        opacity: '1'
      },
      
      "50%": {
        width: "150%",
        maxHeight: "300px",
        opacity: 0,
      },

      "100%": {
        width: "100%",
        maxHeight: "170px",
        opacity: '0'
      },
    },
  },

  img: {
    animation: `image-zooming-overview ${titleIsOnTop ? '3s' : '2s'} infinite ${titleIsOnTop ? 'alternate' : 'alternate-reverse'} linear`,
    width: "100%",
    height: "100%",
    maxHeight: "290px",
    objectFit: "contain",
    margin: theme.spacing(4, 0),

    [theme.breakpoints.down('md')]: {
      maxHeight: "190px",
    },

    [theme.breakpoints.down('sm')]: {
      maxHeight: "170px",
    },

  },

  "@keyframes image-zooming-overview": {
    "0%": {
      transform: "scale(1) rotate(0)",
    },

    "100%": {
      transform: "scale(1.05) rotate(3deg)",
    },
  },

 
}));



const Products = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "70%",
  margin: "auto",

  [theme.breakpoints.down('md')]: {
    width: "100%",
  },

  "div:nth-child(2)": {
    transform: "translateY(30%)",
  },
  "div:nth-child(3)": {
    transform: "translate(-20%, -18%)"

  }
}));

export default ProductOverview;
